<template>
	<div>
		<img src="" alt="" v-on:load="_onLoad" v-on:error="_onError" ref="preloader"
			 style="position: absolute;top: -9999px; width:1px;height:1px"/>
		<div ref="display"
			 style="transition: opacity 2s;width:100%;height:100%;opacity: 0;background-size: cover;background-position: center;"></div>
	</div>

</template>

<script>
	export default {
		name: 'Photo',
		props: {
			msg: String
		},
		data() {
			return {
				loaded: false,
				error: false,
				src: null
			}
		},
		methods: {
			load(url) {
				// console.log(url);
				this.loaded=false;
				this.$refs.preloader.src = this.src = url;
			},
			_onLoad() {
				// console.log(this.src);
				this.loaded = true;

				this.$refs.display.style.backgroundImage = "url('"+this.src+"')";
				this.$emit("photo-load");
			},
			_onError() {
				this.error = true;
				this.$emit("photo-error");
			},
			show() {
				this.$refs.display.style.opacity = "1";
			},
			hide() {
				this.$refs.display.style.opacity = "0";
			}
		},
		mounted() {
          // display = this.$refs.display;
			// /*eslint no-console: "off"*/
			// console.log("created");
			// console.log(display);
			// console.log(this);
		}

	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
